import { Button, Grid, Modal, Typography } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import {
  CD_BALANCE_LINKED_POLICIES_TABS,
  CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS,
} from 'src/utils/constants/common'
import { useEffect, useState } from 'react'
import CdAccountLinkedPoliciesView from 'src/components/ceo/CDBalance/CdAccountLinkedPoliciesView'
import Arrow from 'src/assets/CdBalance_Images/Arrow1.svg'
import { useHistory, useParams } from 'react-router-dom'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { formatDateTime } from 'src/utils/commonMethods/formatDate'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import CdAccountTrack from 'src/components/ceo/CDBalance/CdAccountTrack'
import { getClientId } from 'src/utils/commonMethods'
import { GET_POLICY_LINKED_TO_CD_ACCOUNT } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { COMING_SOON } from 'src/utils/constants/Ceo'

const CdAccountLinkedPolicies = () => {
  const classes = useStyles()
  const history = useHistory()
  const { clientId, id } = useParams()
  const userInfo = useSelector((state) => state.userInfo)
  const requestClientId = getClientId(clientId, userInfo)
  const [selectedTab, setSelectedTab] = useState('')
  const [isTrackModalOpen, setIsTrackModalOpen] = useState(false)
  // eslint-disable-next-line
  const [tabType, setTabType] = useState(
    CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS?.VIEW_TRANSACTION_HISTORY
  )
  const disabledTabs = [
    CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS?.RECHARGE,
    CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS?.CD_BALANCE_CALCULATOR,
  ]

  const {
    loading: cdAccountLinkedPolicyLoading,
    error: cdAccountLinkedPolicyError,
    data: cdAccountLinkedPolicyData,
    refetch,
  } = useQuery(GET_POLICY_LINKED_TO_CD_ACCOUNT(requestClientId, id), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  // const getComponent = () => {
  //   switch (tabType) {
  //     case CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.VIEW_TRANSACTION_HISTORY:
  //       return <CdAccountLinkedPoliciesView />
  //     case CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.CD_BALANCE_CALCULATOR:
  //     case CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS.RECHARGE:
  //     default:
  //       return <CdAccountLinkedPoliciesView />
  //   }
  // }

  const selectDashboard = (type) => {
    setTabType(type)
    setSelectedTab(type)
    if (
      type === CD_BALANCE_LINKED_POLICIES_TYPE_ENUMS?.VIEW_TRANSACTION_HISTORY
    ) {
      setIsTrackModalOpen(true)
    } else {
      setIsTrackModalOpen(false)
    }
  }

  useEffect(() => {
    refetch()
  }, [requestClientId, id, refetch])

  const backNavigation = () => {
    history.push('/individual/dashboard/cdBalanceView/')
  }

  if (cdAccountLinkedPolicyError) {
    return <GraphQlErrors error={cdAccountLinkedPolicyError} />
  }

  const cdAccountData =
    cdAccountLinkedPolicyData?.getPolicyLinkedToCdAccount?.content
  const cdAccountPolicy = cdAccountData?.linkedPolicies?.[0]

  return (
    <>
      <LoadingModal loading={cdAccountLinkedPolicyLoading} />
      <Modal
        id='trackModal'
        open={isTrackModalOpen}
        onClose={() => {
          setIsTrackModalOpen(false)
        }}
      >
        <div className={`${classes.modalRoot} modal-container`}>
          <CdAccountTrack
            cdAccountId={cdAccountData?.cdAccountId}
            setIsTrackModalOpen={setIsTrackModalOpen}
          />
        </div>
      </Modal>
      <div className={classes.backContainer} onClick={backNavigation}>
        <div>
          <img src={Arrow} className={classes.arrowImage} />
        </div>
        <div>
          <span className={classes.back}>Back</span>
        </div>
      </div>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <Grid container className={classes.accountContainer}>
            <Grid item xs={6} sm={4} md={2} lg={2} xl={2}>
              <div className={classes.item}>
                <img
                  src={
                    cdAccountPolicy?.provider?.image
                      ? cdAccountPolicy?.provider?.image
                      : '---'
                  }
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
              <div className={classes.item}>
                <Typography className={classes.accountText}>
                  CD A/c Number
                </Typography>
                <span className={classes.accountText}>
                  {cdAccountData?.cdAccountNumber
                    ? cdAccountData?.cdAccountNumber
                    : '---'}
                </span>
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={4} lg={4} xl={4}>
              <div className={classes.item}>
                <Typography className={classes.accountText}>
                  A/C Balance:
                </Typography>
                <span className={classes.accountText}>
                  {formatToINR(cdAccountData?.currentCdAccountBalance)}
                  {/* Seven Lakh seven thousand Five Hundred Rupees */}
                </span>
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
              <div className={classes.item}>
                <Typography className={classes.accountText}>
                  Last Updated
                </Typography>
                <span className={classes.accountText}>
                  {formatDateTime(cdAccountData?.lastUpdatedOn)
                    ? formatDateTime(cdAccountData?.lastUpdatedOn)
                    : '---'}
                </span>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.subContainer}>
          <div className={classes.tabs}>
            <div className={classes.tabsContent}>
              <div>
                <span className={classes.accountText}>
                  Linked Policies Count:{' '}
                </span>
                <span className={classes.headingText}>
                  {cdAccountData?.linkedPolicies?.length
                    ? cdAccountData?.linkedPolicies?.length
                    : '---'}
                </span>
              </div>
              <div>
                <span className={classes.accountText}>
                  Min Balance Advised:{' '}
                </span>
                <span className={classes.headingText}> --- </span>
              </div>
            </div>
            <div className={classes.tabsContainer}>
              {CD_BALANCE_LINKED_POLICIES_TABS?.map(
                (policiesListItem, index) => {
                  const isDisabledTabs = disabledTabs?.includes(
                    policiesListItem?.value
                  )
                  return (
                    <Button
                      id={policiesListItem?.value}
                      variant='contained'
                      key={`${policiesListItem?.value}${index}`}
                      onClick={() => {
                        selectDashboard(policiesListItem?.value)
                      }}
                      className={classes.tabsLabel}
                    >
                      <div className={classes.imageContent}>
                        <div className={classes.imageItem}>
                          <img
                            src={policiesListItem?.image}
                            className={classes.image}
                          />
                        </div>
                        <div className={classes.textContent}>
                          {selectedTab === policiesListItem?.value &&
                          isDisabledTabs
                            ? COMING_SOON
                            : policiesListItem?.label}
                        </div>
                      </div>
                    </Button>
                  )
                }
              )}
            </div>
          </div>
          <div>
            {/* {getComponent()} */}
            {cdAccountData?.linkedPolicies?.map((data) => (
              <div key={`data_${data?.policyData}`}>
                <CdAccountLinkedPoliciesView policyData={data} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default CdAccountLinkedPolicies
const useStyles = makeStyles({
  backContainer: {
    display: 'flex',
    gap: '10px',
    margin: '40px 50px 0px 50px',
    cursor: 'pointer',
  },
  arrowImage: {
    width: '15px',
  },
  back: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    lineHeight: '18px',
  },
  mainContainer: {
    margin: '20px 50px',
  },
  subContainer: {
    border: '1px solid #BBBBBB',
    background: '#FFF !important',
    borderRadius: '0px 0px 10px 10px',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '25px',
    alignItems: 'center',
  },
  tabsContent: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  accountContainer: {
    background: '#F1EAED',
    textAlign: 'center',
    alignItems: 'center',
    border: '1px solid #BBBBBB',
    borderRadius: '10px 10px 0px 0px',
    padding: '20px',
  },
  accountTextHeading: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '21px',
    fontFamily: 'Roboto',
  },
  accountText: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '21px',
    fontFamily: 'Roboto',
  },
  headingText: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '21px',
    fontFamily: 'Roboto',
    color: '#B92250',
  },
  tabsContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  tabsLabel: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#B92250 !important',
    border: '1px solid #B92250 !important',
    borderRadius: '15px !important',
    padding: '2px 10px !important',
    cursor: 'pointer !important',
    textTransform: 'capitalize !important',
    background: '#FFF !important',
  },
  imageContent: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  },
  image: {
    width: '15px',
  },
  textContent: {
    textTransform: 'capitalize !important',
  },
  item: {
    padding: '10px',
  },
  modalRoot: {
    width: '80%',
    maxHeight: '60%',
    padding: '20px',
    overflowY: 'auto',
    background: '#fff',
    borderRadius: '7px',
  },
  imageItem: {
    display: 'flex',
  },
})
